import { render, staticRenderFns } from "./TagsLabel.vue?vue&type=template&id=5e909a9b&"
import script from "./TagsLabel.vue?vue&type=script&lang=js&"
export * from "./TagsLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports